import { useMemo } from 'react'

import {
  filterDistributions,
  useDistributionListApi,
  useDistributionSearchCondition
} from '@/common/api/modules/recommendationDistribution'
import { useFirstLoading } from '@/common/api/search'
import { distributionNewPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AppTitleBadge from '@/components/container/layout/AppTitleBadge'
import RecommendationDistributionListTable from '@/components/container/modules/recommend/distribution/table/RecommendationDistributionListTable'
import RecommendationDistributionSearchField from '@/components/container/modules/recommend/distribution/table/RecommendationDistributionSearchField'
import TitlePageInfo from '@/components/container/utils/pager/TitlePageInfo'

const RecommendationDistributionListPage = () => {
  const siteId = useSiteId()
  const { data, isLoading } = useDistributionListApi({ site_id: siteId })
  const isFirstLoading = useFirstLoading(isLoading)

  const [condition, setCondition, onUpdatePage] = useDistributionSearchCondition()

  const filtered = useMemo(() => filterDistributions(data ?? [], condition), [data, condition])
  const paged = useMemo(
    () =>
      filtered.slice((condition.page - 1) * condition.perPage, condition.page * condition.perPage),
    [filtered, condition.page, condition.perPage]
  )

  return (
    <Main type={MainLayoutType.FULL}>
      <PageTitle
        title={'配信履歴一覧'}
        badgeNode={<AppTitleBadge type='recommend' />}
        behindNode={
          data && (
            <TitlePageInfo
              page={condition.page}
              perPage={condition.perPage}
              total={filtered.length}
              unit='件'
            />
          )
        }
        rightNode={
          <Button link={distributionNewPath(siteId)} size='large' color={ButtonColor.PRIMARY_BRAND}>
            新たな配信を行う
          </Button>
        }
      />
      <Content>
        {isFirstLoading ? (
          <PageListLoading />
        ) : (
          <Area tableWrap noBorder>
            <RecommendationDistributionSearchField
              condition={condition}
              setCondition={setCondition}
            />
            {filtered.length > 0 ? (
              <RecommendationDistributionListTable
                distributions={paged}
                condition={condition}
                onUpdatePage={onUpdatePage}
                total={filtered.length}
              />
            ) : (
              <NoResultGuidance searched name='配信' />
            )}
          </Area>
        )}
      </Content>
    </Main>
  )
}

export default RecommendationDistributionListPage
